import { isRESTAPIErrorWithStatus } from './isRESTAPIErrorWithStatus';

/** True when `error` is a 409 Conflict from the REST API (e.g. the resource already exists). */
export function isConflictError(error: unknown): boolean {
  return isRESTAPIErrorWithStatus(error, 409);
}
